import useTakeMeToEvent from './use-take-me-to-event.js';

const TakeMeToEvent = () => {
	useTakeMeToEvent();
	return null;
};

export default TakeMeToEvent;
